module.exports = __webpack_public_path__ + "img/9788976334510.7e9cfb97.jpg";